import apiClient from '@/api/index.js'

const state = {
  locations: [],
  location: null,
  loading: false,
  error: null
}

const getters = {
  allLocations: state => state.locations,
  locationById: state => id => state.locations.find(location => location.id === id),
  loading: state => state.loading
}

const actions = {
  fetchLocations({ commit }) {
    commit('SET_LOADING', true)
    apiClient.getLocations()
      .then(response => {
        commit('SET_LOCATIONS', response.data)
        commit('SET_LOADING', false)
      })
      .catch(error => {
        commit('SET_LOADING', false)
        console.error('Error fetching locations:', error)
      })
  },
  fetchLocation({ commit }, id) {
    commit('SET_LOADING', true)
    apiClient.getLocation(id)
      .then(response => {
        commit('SET_LOCATION', response.data)
        commit('SET_LOADING', false)
      })
      .catch(error => {
        commit('SET_LOADING', false)
        console.error('Error fetching location:', error)
      })
  },
  createLocation({ commit }, location) {
    commit('SET_LOADING', true)
    return apiClient.createLocation(location)
      .then(response => {
        // Dependiendo de la respuesta, puede venir en response.data o en response.data.location
        const newLocation = response.data.location || response.data
        commit('ADD_LOCATION', newLocation)
        commit('SET_LOADING', false)
        return newLocation
      })
      .catch(error => {
        commit('SET_LOADING', false)
        return Promise.reject(error)
      })
  },
  updateLocation({ commit }, location) {
    commit('SET_LOADING', true)
    return apiClient.updateLocation(location.id, location)
      .then(response => {
        const updatedLocation = response.data.location || response.data
        commit('UPDATE_LOCATION', updatedLocation)
        commit('SET_LOADING', false)
        return updatedLocation
      })
      .catch(error => {
        commit('SET_LOADING', false)
        return Promise.reject(error)
      })
  },
  deleteLocation({ commit }, id) {
    commit('SET_LOADING', true)
    return apiClient.deleteLocation(id)
      .then(response => {
        commit('DELETE_LOCATION', id)
        commit('SET_LOADING', false)
        return response.data
      })
      .catch(error => {
        commit('SET_LOADING', false)
        return Promise.reject(error)
      })
  }
}

const mutations = {
  SET_LOADING(state, status) {
    state.loading = status
  },
  SET_LOCATIONS(state, locations) {
    state.locations = locations
  },
  SET_LOCATION(state, location) {
    state.location = location
  },
  ADD_LOCATION(state, location) {
    state.locations.push(location)
  },
  UPDATE_LOCATION(state, updatedLocation) {
    const index = state.locations.findIndex(l => l.id === updatedLocation.id)
    if (index !== -1) {
      state.locations.splice(index, 1, updatedLocation)
    }
    if (state.location && state.location.id === updatedLocation.id) {
      state.location = updatedLocation
    }
  },
  DELETE_LOCATION(state, id) {
    state.locations = state.locations.filter(l => l.id !== id)
    if (state.location && state.location.id === id) {
      state.location = null
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
